<template>
  <v-combobox
    v-bind="commonProps"
    :items="items || choices"
    multiple
    filled
    chips
    small-chips
    deletable-chips
    disable-lookup
    @change="changeHandler"
    @input="updateHandler"
  ></v-combobox>
</template>

<script>
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Multiple from '@ilteducation/vuetify-admin/src/mixins/multiple';
import Editable from '@ilteducation/vuetify-admin/src/mixins/editable';
import ReferenceInput from '@ilteducation/vuetify-admin/src/mixins/reference-input';

/**
 * Value editing from a fixed choices. Support multiple and references.
 * If no choices, by default, takes localized enums with source as value from your VueI18n resources locales.
 */
export default {
  mixins: [Input, Multiple, Editable, ReferenceInput],
  props: {
    /**
     * Keep entries containing ', ' intact instead of splitting them into separate values.
     * Needed where a single value may legitimately contain a comma, e.g. some media sources for articles
     */
    disableCommaSplit: Boolean,
  },
  async created() {
    this.items = await this.fetchChoices();
  },
  methods: {
    changeHandler(items) {
      const value = this.separateByComma(items);
      this.change(value);
    },
    updateHandler(items) {
      const value = this.separateByComma(items);
      this.update(value);
    },
    separateByComma(items) {
      if (this.disableCommaSplit) {
        return items;
      }
      if (items.length === 0) {
        return [];
      }
      return items.join(', ').split(', ');
    },
  },
};
</script>
